<template>
  <h-list-page>
    <h-card title="4M1E变更管理-老流程" width="100%" :is-left="0" is-search footer @change-method="changeMethod">
      <h-area>
        <h-search class="searchColItem" title="工厂小微">
          <h-select clearable filterable v-model="searchData.checkfactory" placeholder="请选择">
            <h-option v-for="item in seletByLeval" :key="item.sybId" :label="item.sybName" :value="item.sybName"></h-option>
          </h-select>
        </h-search>
        <h-search class="searchColItem" title="变更类型">
          <h-select v-model="searchData.changetype" placeholder="请选择" style="width: 197px;" clearable>
            <h-option key="1" label="工序设备变更" value="工序设备变更"></h-option>
            <h-option key="2" label="模具变更" value="模具变更"></h-option>
            <h-option key="3" label="模块材料变更" value="模块材料变更"></h-option>
            <h-option key="4" label="模块制造方法变更" value="模块制造方法变更"></h-option>
            <h-option key="5" label="生产场地变更" value="生产场地变更"></h-option>
            <h-option key="6" label="模块构造变更" value="模块构造变更"></h-option>
            <h-option key="7" label="模块检验变更" value="模块检验变更"></h-option>
            <h-option key="8" label="模块包装规格变更" value="模块包装规格变更"></h-option>
          </h-select>
        </h-search>
        <h-search class="searchColItem" title="初审结果">
          <h-select v-model="searchData.SQEsta" placeholder="请选择" style="width: 197px;" clearable @change="changeSqe">
            <h-option key="1" label="驳回" :value="2"></h-option>
            <h-option key="2" label="待审批" :value="0"></h-option>
            <h-option key="3" label="通过" :value="1"></h-option>
          </h-select>
        </h-search>
        <h-search class="searchColItem" title="专用号">
          <h-autocomplete
            popper-class="planHidden"
            v-model="searchData.materialcode"
            :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false"
            @input="() => (searchData.materialcode.length < 4 ? (isShowList = false) : '')"
            @clear="isShowList = false"
            clearable
            placeholder="请输入至少四位专用号"
            @blur="myBlur('isShowList')"
            @focus="myFocus3('isShowList')"
          >
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table
              v-show="isShowList"
              v-loading="mtlNoloading"
              ref="filterTable"
              :data="mtlNoList"
              border
              size="small"
              max-height="252"
              @row-click="clickmtlNo"
              @mousedown="blur = true"
            >
              <el-table-column prop="mtlNo" label="物料号" width="120"></el-table-column>
              <el-table-column prop="mtlName" label="物料名称"></el-table-column>
            </el-table>
          </h-detail>
        </h-search>
        <h-search class="searchColItem" title="物料名称">
          <h-input v-model="searchData.materialname" placeholder="请输入物料名称" clearable></h-input>
        </h-search>
        <h-search class="searchColItem" title="变更申请时间" type="datetimerange">
          <h-date-picker
            @change="TimeChange(inputDate2, { start: 'systimeStart', end: 'systimeEnd' })"
            v-model="inputDate2"
            type="daterange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            clearable
            clear-icon="el-icon-error"
            prefix-icon="iconfont icon-rili2"
          />
        </h-search>
        <template #operate>
          <h-button type="primary" @click="handleCurrentChange(1)">
            <template #icon>
              <search />
            </template>
            查询
          </h-button>
        </template>
      </h-area>
    </h-card>

    <h-table-card title="4M1E变更管理-老流程" :h-data="tableData">
      <template #buttonGroup>
        <template v-for="item in buttonList">
          <h-button type="primary" @click="EXport" :key="item.code" v-if="item.code == 'mkhl_bggl_new_export'">
            <template #icon>
              <i class="iconfont icon-daochu"></i>
            </template>
            导出
          </h-button>
        </template>
      </template>
      <el-table
        empty-text="暂无数据"
        size="small"
        v-loading="loading"
        border
        :data="tableData"
        height="540"
        style="width: 100%;min-height: 540px"
        id="eltableRef"
      >
        <el-table-column type="index" label="序号" width="40" class-name="serial"></el-table-column>
        <el-table-column prop="changename" label="变更名称" width="200"></el-table-column>
        <el-table-column prop="materialcode" label="物料编码" width="130">
          <template #default="row">
            <span @click="goDetail(row.row.id)" style="color:#165dff; cursor:pointer">{{ row.row.materialcode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialname" label="物料名称" width="200"></el-table-column>
        <el-table-column prop="changetype" label="变更类型" width="150"></el-table-column>
        <el-table-column prop="plname" label="适用产品线" width="100"></el-table-column>
        <el-table-column prop="checkfactory" label="申请验证工厂小微" width="130"> </el-table-column>
        <el-table-column prop="applydate" label="变更申请日期" width="120"></el-table-column>
        <el-table-column prop="inventoryAmounts" label="库存数量" width="100"></el-table-column>
        <el-table-column prop="inventoryCompletionTime" label="库存消化完成时间" width="150"></el-table-column>
        <el-table-column label="初审结果" width="100">
          <template #default="{row}">
            <span v-if="row.process === 9">废弃</span>
            <span v-else-if="row.sqesta === 0">待审批</span>
            <span v-else-if="row.sqesta === 1">通过</span>
            <span v-else-if="row.sqesta === 2">驳回</span>
          </template>
        </el-table-column>
        <el-table-column label="审批结果" width="100">
          <template #default="{row}">
            <span v-if="row.process === 9">废弃</span>
            <span v-else-if="row.factorysta === 1 && row.praisesta === 1 && row.devsta === 1">通过</span>
            <span v-else-if="row.factorysta === 2 && row.praisesta === 2 && row.devsta === 2">驳回</span>
            <span v-else>待审批</span>
          </template>
        </el-table-column>
        <el-table-column prop="sqeLeaderName" label="SQE负责人" width="130"></el-table-column>
        <el-table-column prop="sqeLeaderTime" label="SQE负责人审核时间" width="170"></el-table-column>
        <el-table-column prop="sqeLeaderStatus" label="SQE负责人审核结论" width="170">
          <template #default="{row}">
            <span v-if="row.sqeLeaderStatus === 'N'">待审核</span>
            <span v-if="row.sqeLeaderStatus === 'P'">通过</span>
            <span v-if="row.sqeLeaderStatus === 'F'">驳回</span>
          </template>
        </el-table-column>
        <el-table-column prop="sampleCheckResult" label="样品检验结果" width="120">
          <template #default="{row}">
            <span v-if="row.sampleCheckResult === 'Y'">待验证</span>
            <span v-if="row.sampleCheckResult === 'N'">无需验证</span>
            <span v-if="row.sampleCheckResult === 'P'">合格</span>
            <span v-if="row.sampleCheckResult === 'F'">不合格</span>
          </template>
        </el-table-column>
        <el-table-column prop="smallBatchVerificationResult" label="小批验证结果" width="120">
          <template #default="{row}">
            <span v-if="row.smallBatchVerificationResult === 'Y'">待验证</span>
            <span v-if="row.smallBatchVerificationResult === 'N'">无需验证</span>
            <span v-if="row.smallBatchVerificationResult === 'P'">合格</span>
            <span v-if="row.smallBatchVerificationResult === 'F'">不合格</span>
          </template>
        </el-table-column>
        <el-table-column prop="devProductVerificationResult" label="产品验证结果" width="120">
          <template #default="{row}">
            <span v-if="row.devProductVerificationResult === 'Y'">待验证</span>
            <span v-if="row.devProductVerificationResult === 'N'">无需验证</span>
            <span v-if="row.devProductVerificationResult === 'P'">合格</span>
            <span v-if="row.devProductVerificationResult === 'F'">不合格</span>
          </template>
        </el-table-column>
        <el-table-column prop="finalResult" label="最终结论" width="100">
          <template #default="{row}">
            <span v-if="row.finalResult === 'Y'">可变更</span>
            <span v-if="row.finalResult === 'N'">不可变更</span>
          </template>
        </el-table-column>
        <el-table-column prop="validStatus" label="有效性" width="100">
          <template #default="{row}">
            <span v-if="row.validStatus === 'Y'">有效</span>
            <span v-if="row.validStatus === 'N'">无效</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        v-model:current="pagenation.pageNumber"
        v-model:currentPage="pagenation.pageNumber"
        :page-size="10"
        layout="total, prev, pager, next,jumper"
        :total="total"
      ></el-pagination>
    </h-table-card>
  </h-list-page>
</template>
<script>
import moment from 'moment';
export default {
  data() {
    return {
      keepalivestatus: 0,
      pagenation: {
        pageNumber: 1,
        pageSize: 10
      },
      inputDate2: '',
      total: 0,
      loading: false,
      fanye: false,
      mtlNoList: [],
      isShowList: false,
      mtlNoloading: false,
      supplierList: [],
      isShowsupplierList: false,
      blur: false,
      EXportloading: false,
      tableData: [],
      buttonList: [], //按钮权限
      searchData: {
        materialcode: ''
      },
      plList: [], //产业 数据
      seletByLeval: [], //  互联工厂
      sybList: [] //小微 数据
    };
  },
  methods: {
    changeSqe(val) {
      if (val === 0 || val === 1 || val === 2) {
        this.searchData.SQEsta = val
      } else {
        this.searchData.SQEsta = ''
        return
      }
    },
    // 展开收起高度改变
    changeMethod() {
      this.changeHeight();
    },
    // 时间范围选择
    TimeChange(date, { start, end }) {
      if (date) {
        this.searchData[start] = this.time(date[0]);
        this.searchData[end] = this.time(date[1]);
      } else {
        this.searchData[start] = undefined;
        this.searchData[end] = undefined;
      }
    },
    clicksupplierCode(row) {
      this.blur = true;
      this.searchData.vcode = row.supplyCode;
      this.isShowsupplierList = false;
    },
    goDetail(id) {
      this.$router.push({
        name: 'oldChangeManagementDetail',
        query: {
          rejectsId: id
        }
      });
    },
    // 导出
    EXport() {
      if (this.total > 200000) {
        this.warning({
          message: '导出失败，导出数量大于200000条',
          title: '信息提示',
          confirmButtonText: '确定',
          callback: action => {}
        });
        return;
      }
      if (this.total < 1) {
        this.warning({
          message: '导出失败，导出数量小于1条',
          title: '信息提示',
          confirmButtonText: '确定',
          callback: action => {}
        });
        return;
      }
      this.exportLoading = true;
      this.startLoading('变更管理导出中...');
      this.httpFile(
        {
          method: 'post',
          url: '/base/changeManagementOld/exportChangeManagementInfo',
          data: {
            ...this.searchData,
            fixConfig: true,
            vcode: this.$route.query.name,
            ...this.pagenation,
            flag: 'sqm'
          }
        },
        '变更管理.xlsx'
      )
        .then(res => {
          this.exportLoading = false;
        })
        .catch(err => {
          this.exportLoading = false;
          this.closeLoading();
        });
      this.exportLoading = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      if (!this.fanye) {
        this.fanye = true;
        this.queryData(val);
      } else {
        return false;
      }
    },
    // 查询方法
    queryData() {
      this.loading = true;
      let params = { ...this.searchData };
      this.$http({
        method: 'post',
        url: '/base/changeManagementOld/selectChangeManagementInfo',
        data: {
          fixConfig: true,
          vcode: this.$route.query.name,
          ...this.pagenation,
          ...params
        }
      })
        .then(res => {
          console.log(res, '查询数据');
          this.loading = false;
          this.fanye = false;
          if (res.data.msg === '成功') {
            if (res.data.data.records) {
              this.tableData = res.data.data.records;
              this.total = res.data.data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          }
        })
        .catch(err => {
          this.loading = false;
          this.fanye = false;
          this.error('查询失败' + this.errorDispose(err.response.data || err.response || err));
        });
    },
    //按钮权限列表
    onButtonList() {
      if (
        this.$route.query.parentId &&
        this.$route.query.parentId != 'null' &&
        this.$route.query.parentId != 'undefined' &&
        this.$route.query.parentId != ''
      ) {
        let p = this.getButtonFromSqm(this.$route.query.parentId, this.$route.query.roleCode);
        p.then(res => {
          if (res.length > 0) {
            this.buttonList = res;
          }
        });
      }
    },
    //产品线 查询 //产业
    productLines() {
      // data.loading = true
      this.$http({
        url: '/base/basicData/listPlInfoByName?name=' + this.$route.query.name,
        method: 'get'
      }).then(res => {
        if (res.data.success) {
          // console.log(res, '产品线数据')
          res.data.data ? (this.plList = res.data.data) : '';
        }
      });
    },
    //互联工厂
    seletByLevalQuery() {
      this.$http({
        url: "/base/OqcA/listSyb",
        // url: '/base/common/getQuerySybList?userCode=' + this.$route.query.name,
        method: 'get'
      }).then(res => {
        console.log(res.data, '互联数据');
        if (res.data && res.data.length) {
          this.seletByLeval = res.data.map(item=>{
            item.sybName = item.departmentName,
            item.sybId = item.departmentId
            return item
          })
        } else {
          this.seletByLeval = [];
        }
      });
    },
    //供应商代码模糊查找
    supplierCodeChange() {
      this.blur = false;
      if (this.searchData.vcode.length < 2) {
        console.log('1111111', 1);
        this.isShowsupplierList = false;
      } else {
        console.log('2222222', 2);
        this.mtlNoloading = true;
        this.isShowsupplierList = true;
        this.$http({
          method: 'post',
          url: '/base/basicData/searchSupplierList',
          headers: { 'content-type': 'application/json' },
          data: {
            supplyCode: this.searchData.vcode
          }
        })
          .then(res => {
            this.supplierList = res.data.data;
            this.mtlNoloading = false;
          })
          .catch(e => {});
      }
    },
    //专用号模糊查找
    mtlNoChange(queryString, cb) {
      let this_ = this;
      this_.blur = false;
      if (this_.searchData.materialcode.length < 4) {
        this_.isShowList = false;
      } else {
        this_.mtlNoloading = true;
        this_.isShowList = true;
        this_
          .$http({
            method: 'POST',
            url: '/base/basicData/searchMaterielList',
            headers: { 'content-type': 'application/json' },
            data: {
              mtlNo: this.searchData.materialcode
            }
          })
          .then(res => {
            this_.mtlNoList = res.data.data;
            this_.mtlNoloading = false;
          });
      }
    },
    //专用号
    clickmtlNo(row) {
      this.blur = true;
      this.searchData.materialcode = row.mtlNo;
      this.isShowList = false;
    },
    myBlur(v) {
      if (!this.blur) {
        this[v] = false;
      }
    },
    myFocus3(v) {
      this.blur = false;
      if (this.searchData.materialcode.length >= 4) {
        this[v] = true;
      }
    },
    myFocus4(v) {
      this.blur = false;
      if (this.searchData.vcode.length >= 2) {
        this[v] = true;
      }
    }
  },
  mounted() {
    // this.productLines(); //产业小微
    this.seletByLevalQuery(); //互联工厂
    this.queryData(); //列表数据
    this.onButtonList(); //按钮权限
    this.changeHeight(); //高度
  },
  activated() {
    this.postThisPageHeight();
    if (this.keepalivestatus == 0) {
    } else {
      this.queryData();
    }
  },
  deactivated() {
    this.keepalivestatus = this.keepalivestatus + 1;
  }
};
</script>
<style lang="scss">
.planHidden {
  display: none;
}
.oldChangeManagement {
  .el-table {
    .cell {
      text-align: left !important;
    }
    .serial {
      .cell {
        text-align: center !important;
      }
    }
  }
}
</style>
